'use strict';

var novicell = novicell || {};

novicell.trainers = novicell.trainers || function() {
    var body = document.body;

    function init() {
        let readMoreBtn = jQuery('.read-more');
        if(readMoreBtn.length > 0){
            readMoreBtn.click(function (){
                jQuery(this).closest('.trainer-description').toggleClass('reveal');
            });
        }

        let btnClose = jQuery('.dialog-popup .close');
        if(btnClose.length > 0){
            btnClose.click(function(){
                jQuery(this).closest('.dialog-popup').removeClass('show');
            });
        }

        let lockVideoBtn = jQuery('.video-section__item-image.locked');
        if(lockVideoBtn.length > 0){
            lockVideoBtn.click(function(){
                jQuery('#loginRequired').addClass('show');
            });
        }

    }

    return {
        init: init
    };
}();
